var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('game-list',{attrs:{"playerName":_vm.playerName,"autoConnect":_vm.autoConnect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }